/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, array, string, arrayOf,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { isEmpty } from '../../../utils/object';
import { dateMMMMDDYYYY } from '../../../utils/dateString';

const styles = (theme) => ({
    orderRow: {
        backgroundColor: theme.palette.white,
        margin: '12px 0',
        padding: '0px 12px',
    },
    orderHeader: {
        fontSize: 14,
        // xbackgroundColor: theme.palette.orderDetail.orderHeaderBg,
        padding: '0px 12px !important',
    },
    orderHeaderInner: {
        padding: 24,
    },
    pageHeading: {
        fontWeight: 700,
        textTransform: 'uppercase',
        fontSize: '16px !important',
        color: theme.palette.myAccount.contentGridBorder,
    },
    pageHeadingContent: {
        fontSize: '16px !important',
        fontWeight: 700,
    },
    pageHeadingInner: {
        textAlign: 'right',
    },
});
const DesktopOrderNumber = ({
    orderDetailById, classes, ROSSOrder,
}) => {

    const ROSSOrderDateString = dateMMMMDDYYYY(ROSSOrder?.orders?.[0]?.billingProfile?.orderDate);

    if (isEmpty(orderDetailById) && isEmpty(ROSSOrder)) return null;

    return (
        <>
            <Grid className={`gray-bg ${classes.orderHeaderInner}`} container>
                <Grid item xs={4}>
                    <span className={classes.pageHeading}>Order #: </span>
                    <span className={classes.pageHeadingContent}>{ROSSOrder.orderID || ROSSOrder.orderNumber}</span>
                </Grid>
                <Grid item xs={4}>
                    {ROSSOrder.orders[0].parentOrderNumber && (
                        <div>
                            <span className={classes.pageHeading}>
                                Replacement for:{' '}
                            </span>
                            <span className={classes.pageHeadingContent}>{ROSSOrder.orders[0].parentOrderNumber}</span>
                        </div>
                    )}
                </Grid>
                <Grid item xs={4}>
                    <span className={classes.pageHeading}>Order Date: </span>
                    <span className={classes.pageHeadingContent}>{ROSSOrderDateString}</span>
                </Grid>
            </Grid>

        </>
    )
};

DesktopOrderNumber.defaultProps = {
    orderDetailById: [],
    ROSSOrder: {},
};

DesktopOrderNumber.propTypes = {
    orderDetailById: array,
    classes: object.isRequired,
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        orders: arrayOf(shape({
            actualDeliveryDate: string,
            address: string,
            carrier: string,
            courier: string,
            createdDate: string,
            currentLocation: object,
            deliveryDate: string,
            deliveryImageURL: string,
            deliveryMethod: string,
            deliveryNotes: string,
            history: arrayOf(shape({
                codeStatus: string,
                createdDate: string,
                location: object,
                status: string,
                statusDescription: string,
            })),
            intOrderNumber: string,
        })),
        items: arrayOf(shape({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        })),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }),
};

export default withStyles(styles)(DesktopOrderNumber);
